export default {
  // Forms
  'form.name': 'Name',
  'form.email': 'Email',
  'form.password': 'Password',
  'form.action.returnToSignIn': 'Return to sign in',
  'signIn.title': 'Sign In',
  'signIn.action.signUp': 'Sign up for a new account',
  'signIn.action.signIn': 'Sign In',
  'signIn.action.resetPassword': "I'm having trouble logging in",
  'signUp.title': 'Sign Up',
  'signUp.action.signUp': 'Sign Up',
  'resetPassword.title': 'Reset Password',
  'resetPassword.action.reset': 'Send Reset Password Instructions',

  // Pages
  'pageNotFound.title': 'Page not found',

  // Error Messages
  'name.presence': 'Name is required',
  'email.presence': 'Email is required',
  'email.invalid': 'Please provide a valid email address',
  'password.presence': 'Password is required',
  'password.minLength': 'Password must be at least 6 characters',
};
